import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldIdByNftVariables = Types.Exact<{
  tokenId: Types.Scalars['Int'];
  contractAddress: Types.Scalars['String'];
}>;


export type ApiWorldIdByNft = { world: { id: number } | null };



export const ApiWorldIdByNftDocument = /*#__PURE__*/ `
    query WorldIdByNft($tokenId: Int!, $contractAddress: String!) {
  world(nft: {tokenId: $tokenId, contractAddress: $contractAddress}) {
    id
  }
}
    `;

export const useWorldIdByNft = <
      TData = ApiWorldIdByNft,
      TError = ClientError
    >(
      variables: ApiWorldIdByNftVariables,
      options?: Omit<UseQueryOptions<ApiWorldIdByNft, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldIdByNft, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldIdByNft, TError, TData>(
      {
    queryKey: ['WorldIdByNft', variables],
    queryFn: apiFetcher<ApiWorldIdByNft, ApiWorldIdByNftVariables>(ApiWorldIdByNftDocument, variables),
    ...options
  }
    )};

useWorldIdByNft.getKey = (variables: ApiWorldIdByNftVariables) => ['WorldIdByNft', variables];

export const useInfiniteWorldIdByNft = <
      TData = InfiniteData<ApiWorldIdByNft>,
      TError = ClientError
    >(
      variables: ApiWorldIdByNftVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldIdByNft, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldIdByNft, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldIdByNft, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldIdByNft.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldIdByNft, ApiWorldIdByNftVariables>(ApiWorldIdByNftDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldIdByNft.getKey = (variables: ApiWorldIdByNftVariables) => ['WorldIdByNft.infinite', variables];


useWorldIdByNft.fetcher = (variables: ApiWorldIdByNftVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldIdByNft, ApiWorldIdByNftVariables>(ApiWorldIdByNftDocument, variables, options);
